import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { generateContractPDF } from '@/lib/contract-pdf';
import { formatUZS } from '@/lib/format';
import { FileDown, HandCoins } from 'lucide-react';

interface MurabahaDoneActionsProps {
  contractNumber: string;
  customerName: string;
  customerPhone?: string | null;
  passport?: string | null;
  pinfl?: string | null;
  totalAmount: number;
  monthlyPayment: number;
  termMonths: number;
  schedule: Array<{ n: number; due_date: string; amount: number; remaining: number }>;
  merchantPayout: number;
  items: Array<{ product_name: string; quantity: number; unit_price: number; total: number; unit: string; mhik: string }>;
  onFinish: () => void;
  disabled?: boolean;
}

/** Tayyor qadamidagi amallar: PDF, Telegram/SMS, yangi savdo */
export function MurabahaDoneActions({
  contractNumber,
  customerName,
  customerPhone,
  passport,
  pinfl,
  totalAmount,
  monthlyPayment,
  termMonths,
  schedule,
  merchantPayout,
  items,
  onFinish,
  disabled,
}: MurabahaDoneActionsProps) {
  const { t } = useTranslation();
  const handlePrint = () => {
    generateContractPDF({
      contract: {
        contract_number: contractNumber || '—',
        total_amount: totalAmount,
        monthly_payment: monthlyPayment,
        term_months: termMonths,
        created_at: new Date().toISOString(),
        status: 'signed',
      },
      customer: { full_name: customerName, phone: customerPhone || '', passport, pinfl },
      schedule,
      saleItems: items,
    });
  };

  return (
    <div className="space-y-4">
      <div className="grid gap-3 rounded-xl bg-muted p-4 text-left sm:grid-cols-2">
        <div>
          <p className="text-sm text-muted-foreground">{t('pos_done.customer_pays')}</p>
          <p className="text-lg font-bold tabular-nums text-foreground">{formatUZS(totalAmount)}</p>
        </div>
        <div>
          <p className="text-sm text-muted-foreground">{t('pos_done.merchant_gets')}</p>
          <p className="text-lg font-bold tabular-nums text-success">{formatUZS(merchantPayout)}</p>
        </div>
      </div>

      <Button variant="outline" className="h-14 w-full text-base" onClick={handlePrint} disabled={disabled}>
        <FileDown size={18} className="mr-2" /> {t('pos_done.print_pdf')}
      </Button>

      <Button onClick={onFinish} className="h-14 w-full text-base font-semibold" disabled={disabled}>
        <HandCoins size={20} className="mr-2" /> {t('pos_done.finish')}
      </Button>
    </div>
  );
}
